var _defs, _ellipse, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g2, _g3, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g5, _path61, _path62, _path63, _path64, _path65, _g6, _rect, _rect2, _rect3, _g7, _g8, _g9, _g10, _path66, _path67, _path68, _path69, _path70, _g11, _path71, _path72, _path73, _path74, _ellipse3, _path75, _g12, _g13, _path76, _path77, _g14, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g15, _g16, _path87, _g17, _g18, _g19, _g20, _g21, _path88, _path89, _path90, _g22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 625.706,
    height: 644.231,
    viewBox: "0 0 625.706 644.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.963,
    y1: 0.195,
    x2: 0.427,
    y2: 0.784,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172652",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00579f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 113.472,
    y1: 0.192,
    x2: 112.855,
    y2: 0.772,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 63.801,
    y1: 10.041,
    x2: 63.617,
    y2: 10.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 28.802,
    y1: -1.16,
    x2: 30.007,
    y2: -0.126,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ccc6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#80c668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#61b85b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#39a54a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 24.177,
    y1: -1.388,
    x2: 24.746,
    y2: -0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#007bc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-2124.046 -2984.786)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 271.085,
    cy: 35.77,
    rx: 271.085,
    ry: 35.77,
    transform: "translate(2166.431 3557.477)",
    fill: "#eceff8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M1895.688,1117.737s-10.25,50.71,15.105,58.8,26.973,2.158,26.973,2.158l33.048-9.013a9.911,9.911,0,0,0,5.126-3.367c5.071-6.327,14.633-24.59-.412-62.066C1956.11,1055.877,1895.688,1117.737,1895.688,1117.737Z",
    transform: "translate(508.399 2201.986)",
    fill: "#ff4f78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(2398.692 3569.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1935.379,2673.159c-23.317,4.664-60.234-3.915-60.234-3.915l7.067-1.833,6.747-17.146c10.174,2.332,37.093-4.873,37.093-4.873l7.17,21.353Z",
    transform: "translate(-1875.145 -2645.393)",
    fill: "#fbbd9d"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1926.634,2702.026l-11.329-1.079s-40.46,1.079-48.012,3.776-19.96,4.855-16.184-1.618,18.881-14.026,18.881-14.026l30.21-10.25,19.421,12.947Z",
    transform: "translate(543.807 897.141)",
    fill: "#fbc7aa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M1950.288,2631.994c-23.317,4.664-60.234-3.914-60.234-3.914l8.092-11.868c7.272.977,28.146,7.612,45.315,3.237Z",
    transform: "translate(511.336 948.43)",
    fill: "#f4b999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1976.11,2493.573s16.055-11.7,20.665-19h50.551v18.294l-57.545,18.758Z",
    transform: "translate(440.849 1064.445)",
    fill: "#fbc7aa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M1919.452,1328.08s-2.7,41,21.039,46.934,7.553-18.207,7.553-18.207Z",
    transform: "translate(487.332 2003.511)",
    fill: "#ed3560",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M2164.1,1288.361s8.816-8.692,16.369,1.019-5.125,41.809-13.891,47.608-13.7,2.535-13.7,2.535l-6.4-12.92Z",
    transform: "translate(301.297 2038.975)",
    fill: "#ed3560",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M1979.289,1467.591c.284.2,1.628,13.165,1.628,13.165s-8.032,4.492-14.178,5.763c0,0,29.283,28.763,55.107-8.054a37.971,37.971,0,0,1-12.891-1.272l-4.239-17.38Z",
    transform: "translate(448.525 1895.611)",
    fill: "#f4b999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M1656.555,1951.273l-16.723,7.013s-10.25,16.723,0,25.894,41.539,2.7,41.539,2.7l-19.421-15.105Z",
    transform: "translate(720.019 1493.067)",
    fill: "#27b0b1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M1834.94,1624.891c-3.195-10.851-7.064-22.356-11.023-30.275-14.053-28.106-36.684-34.526-56.1-39.92,0,0-3.512,12.833-21.716,18.554-18.059,4.643-30.765-9.015-30.765-9.015-22.043,12.081-55.531,69.308-55.531,69.308l33.064,69.308L1798.7,1705.4v-39.423c15.26-11.446,44.23-10.927,44.23-10.927A146.514,146.514,0,0,0,1834.94,1624.891Z",
    transform: "translate(699.932 1817.895)",
    fill: "#40cecf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M2299.608,1917.616c-.171-1.711,17.473,50.391,17.473,50.391l1.762,11.445-17.57,15.794-8.235-6.416S2307.716,1998.529,2299.608,1917.616Z",
    transform: "translate(181.26 1520.668)",
    fill: "#27b0b1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M1829.665,1832s-16,26.813-14.565,44.776l13.487.54S1822.112,1867.067,1829.665,1832Z",
    transform: "translate(572.804 1590.759)",
    fill: "#27b0b1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M2055,2607.982s-20.068,10.053-25,10.371,2.543,2.543,2.543,2.543l24.14-7.869Z",
    transform: "translate(398.085 955.17)",
    fill: "#e4a482"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M2179.176,2378.186c-15.26,61.991-103.646,53.41-112.866,48.639a9.472,9.472,0,0,1-3.15-2.857,27.941,27.941,0,0,1-3.529-6.91c-3.856-10.411-5.087-24.887-5.087-24.887,5.38-4.438,20.257-12.4,35.636-20.116-27.428-.813-54.02-15.217-54.02-15.217s79.5-12.035,107.406-16.168c22.064-3.269,31.5,22.092,34.479,32.848l.011.04C2178.843,2376.38,2179.176,2378.186,2179.176,2378.186Z",
    transform: "translate(391.663 1174.357)",
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M2285.43,2528.2c-15.261,61.991-103.646,53.41-112.866,48.639a9.474,9.474,0,0,1-3.15-2.857,27.933,27.933,0,0,1-3.529-6.91v-2.151s89.633,15.622,118.416-41.39l.011.04C2285.1,2526.4,2285.43,2528.2,2285.43,2528.2Z",
    transform: "translate(285.408 1024.341)",
    fill: "#bababa",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M2240.72,2475.188s20.639-8.02,27.633-8.894c0,0-41.793,8.094-48.4,6.916C2219.952,2473.209,2238.71,2475.956,2240.72,2475.188Z",
    transform: "translate(241.123 1071.224)",
    fill: "#bababa",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M1966.045,1161.963c-4.882,14.808-10.973,21.789-26.974,22.658a29.235,29.235,0,0,1-9.538-1.651c-5.319-2.039-9.6-6.258-12.985-11.9q-.575-.963-1.117-1.974a55.38,55.38,0,0,1-2.692-5.837,114.14,114.14,0,0,1-4.181-12.9c-.043-.151-.081-.3-.119-.453-.237-.9-.453-1.775-.658-2.627-1.9-7.892-2.67-13.859-2.67-13.859l8.254-15.973,16.9-9.959,41.253,10.752S1972.362,1142.818,1966.045,1161.963Z",
    transform: "translate(499.002 2184.194)",
    fill: "#fbc7aa"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1922.22,1041.1a19.6,19.6,0,0,0,3.318-.822s6.357-4.548,8.88-.842,9.312,26.272,34.318,26.835l.171.494,4.721,13.69s21.724-15.669,11.382-42.485-33.382-22.123-33.382-22.123-26.369-10.016-40.431,12.6C1901.079,1044.726,1917.523,1041.811,1922.22,1041.1Z",
    transform: "translate(496.665 2261.066)",
    fill: "#ff4f78"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M1962.4,1359l-1.669,4.654s-1.823-1.773-.659-3.533A2.927,2.927,0,0,1,1962.4,1359Z",
    transform: "translate(454.299 1978.189)",
    fill: "#ffba94"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M2039.192,1346.8c.044,0,.088,0,.133,0l1.736-.106a.389.389,0,0,0,.319-.431c-.008-.227-.173-.417-.349-.391l-1.736.106a1.6,1.6,0,0,1-1.377-.772,3.9,3.9,0,0,1-.669-2.132l-.009-.243c-.023-.643.275-1.186.666-1.21a1.923,1.923,0,0,0,1.49-1.038,4.045,4.045,0,0,0,.52-2.211l-.142-3.466c-.01-.228-.19-.405-.351-.389a.392.392,0,0,0-.318.434l.142,3.463a3.079,3.079,0,0,1-.389,1.682,1.283,1.283,0,0,1-.982.7c-.759.047-1.344.977-1.3,2.072l.009.243a4.824,4.824,0,0,0,.838,2.642A2.26,2.26,0,0,0,2039.192,1346.8Z",
    transform: "translate(391.327 1998.245)",
    fill: "#ff806d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 11.725,
    cy: 10.683,
    rx: 11.725,
    ry: 10.683,
    transform: "matrix(0.221, -0.975, 0.975, 0.221, 2441.77, 3347.705)",
    fill: "#f9b6a1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1931.617,1362.976q-.574-.963-1.117-1.974a55.368,55.368,0,0,1-2.692-5.837,114.134,114.134,0,0,1-4.181-12.9c-.043-.151-.081-.3-.119-.453a11.648,11.648,0,0,1,11.334,7.407C1937.006,1354.36,1935.539,1360.041,1931.617,1362.976Z",
    transform: "translate(483.933 1992.288)",
    fill: "#f9b6a1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M2113.815,1309.034a2.251,2.251,0,1,0,1.891-2.979A2.53,2.53,0,0,0,2113.815,1309.034Z",
    transform: "translate(328.073 2021.56)",
    fill: "#383b54"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M2132.364,1307.195a3.89,3.89,0,0,0,1.6-1.528,7.957,7.957,0,0,1-.7,1.978C2132.861,1308.249,2132.364,1307.195,2132.364,1307.195Z",
    transform: "translate(312.865 2021.869)",
    fill: "#383b54"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1987.716,1324.434c.313,1.522-.372,2.972-1.53,3.239s-2.35-.752-2.663-2.274.372-2.973,1.53-3.239S1987.4,1322.911,1987.716,1324.434Z",
    transform: "translate(434.84 2008.396)",
    fill: "#383b54"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1978.475,1328.336a3.705,3.705,0,0,1-1.95-.963,8.049,8.049,0,0,0,1.254,1.689C1978.333,1329.518,1978.475,1328.336,1978.475,1328.336Z",
    transform: "translate(440.509 2004.09)",
    fill: "#383b54"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M2220.47,1114.493s10.467-18.555,2.92-33.074C2223.39,1081.419,2228.609,1098.71,2220.47,1114.493Z",
    transform: "translate(240.699 2205.546)",
    fill: "#ed3560"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M2146.648,1092.4s15.373-14.749,12.335-30.827C2158.983,1061.573,2158.992,1079.634,2146.648,1092.4Z",
    transform: "translate(301.165 2221.802)",
    fill: "#ed3560"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1986.755,1123.959a19.6,19.6,0,0,0,3.318-.822s6.357-4.548,8.88-.843,9.312,26.272,34.318,26.835l.171.494c1.872-.745,1.328-1.357-3.795-1.618-18.222-.932-24.455-25.049-30.578-30.921s-11.348,1.417-11.348,1.417Z",
    transform: "translate(432.13 2178.206)",
    fill: "#ed3560",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M12.843,1.651a15.523,15.523,0,0,1-2.956.511c-1.061.118-2.127.248-3.052.376s-1.99.293-3.044.469a15.357,15.357,0,0,1-2.974.311C0,3.274-.374,2.874.5,2.2A14.619,14.619,0,0,1,6.641.214,13.751,13.751,0,0,1,12.963.47C13.93.891,13.63,1.384,12.843,1.651Z",
    transform: "translate(2437.445 3317.678) rotate(9)",
    fill: "#f42a4b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M.81,2.31a15.516,15.516,0,0,0,3,.083c1.067-.035,2.14-.059,3.075-.064s2.012.005,3.08.028a15.38,15.38,0,0,0,2.988-.118c.8-.161,1.114-.61.147-1.155A14.618,14.618,0,0,0,6.742,0,13.752,13.752,0,0,0,.522,1.158C-.375,1.713-.008,2.158.81,2.31Z",
    transform: "translate(2409.397 3322.786) rotate(-14)",
    fill: "#f42a4b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M2237.506,1292.525s2.635-7.805,10.017-5.4,7.273,14.3,1.7,20-10.926.524-10.926.524Z",
    transform: "translate(226.745 2037.435)",
    fill: "#fbc7aa"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M2265.016,1332.389a.7.7,0,0,1-.488-.181l-3.96-3.871,3.888-4.772c-.271.116.308-.324.615-.053a.78.78,0,0,1,.082,1.066l-2.951,3.621,3.269,2.858a.779.779,0,0,1,.079,1.066A.711.711,0,0,1,2265.016,1332.389Z",
    transform: "translate(207.855 2007.327)",
    fill: "#ff806d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M1739.758,1608.025l-1.816-2.083s-12.418-1.3-18.145-12.483c0,0-8.632,2.7-20.5,11.329s-38.842,60.42-38.842,60.42l56.644-52.868Z",
    transform: "translate(699.395 1786.145)",
    fill: "#27b0b1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M2055.654,1435.7s3.636,3.755,8.366,2.889,5.341-4.729,5.571-6.147Z",
    transform: "translate(374.956 1918.03)",
    fill: "#ff806d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M2215.068,1280.087s5.395,32.908,0,42.078c0,0,8.092-8.092,5.395-44.776",
    transform: "translate(245.123 2045.03)",
    fill: "#ff4f78"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1897.045,1086.559s-1.242,12.455-14.385,21.771.54,32.368.54,32.368-31.829-22.118-10.79-56.1a26.622,26.622,0,0,1,20.064-12.832C1906.76,1070.118,1897.045,1086.559,1897.045,1086.559Z",
    transform: "translate(531.677 2213.55)",
    fill: "#ff4f78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M2320.539,2355.14s-17.66,20.358-39.443,24.625l-8.835-4.365-.54-10.25,35.065-8.092Z",
    transform: "translate(198.72 1162.268)",
    fill: "#bababa",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M1409.576,2273.193s-69.48-1.225-92.249,13.487c-35.065,22.658-11.4,76.174,25.895,80.38,71.749,8.092,98.183-20.5,98.183-20.5s-7.813-14.007-8.492-21.839l9.919-8.579Z",
    transform: "translate(994.51 1229.409)",
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1505.06,2404.76s-4.316-3.237-14.566-3.237c0,0,5.934,2.7,9.171,11.868s4.855,17.263,21.578,25.355,96.565-11.868,108.972-16.723S1505.06,2404.76,1505.06,2404.76Z",
    transform: "translate(838.607 1124.276)",
    fill: "#bababa",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M2432.738,2122s4.316,12.947,3.776,19.421,10.79,15.645,23.2,7.013,6.474-36.144,6.474-36.144S2444.067,2113.369,2432.738,2122Z",
    transform: "translate(66.835 1361.181)",
    fill: "#fbc7aa"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M2270.644,2207.3s-5.934-2.158-23.737,14.566c-12.8,12.025-23.923,20.785-23.923,20.785s.852,6.188,10.5,6.728,54.423-23.2,54.423-23.2S2287.368,2210.533,2270.644,2207.3Z",
    transform: "translate(238.639 1283.438)",
    fill: "#fbc7aa"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M2255.933,2428.393l-22.975-.034.54,8.631Z",
    transform: "translate(230.47 1102.296)",
    fill: "#606060"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M2164.378,2364.164s7.552-6.473,18.881-2.158,8.092,10.789,3.777,12.408-17.263,2.158-17.263,2.158Z",
    transform: "translate(286.643 1157.859)",
    fill: "#fbc7aa"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1446.63,2080.5h117.653l23.736,78.548H1473.134a7.313,7.313,0,0,1-6.973-5.11l-23.6-67.88A4.271,4.271,0,0,1,1446.63,2080.5Z",
    transform: "translate(878.036 1387.222)",
    fill: "#1d3151"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M2232.958,2436.607l22.975-8.057v7.789l-20.347,7.789Z",
    transform: "translate(230.47 1102.139)",
    fill: "#0e182c"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1688.189,2471.6H1567.945l.91,2.626a7.674,7.674,0,0,0,7.251,5.163h114.781Z",
    transform: "translate(775.169 1066.875)",
    fill: "#7c7c7c"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M2116.28,2080.063l1.968-.093a2.429,2.429,0,0,1,2.436,1.707l21.022,67.795-4.316,1.619Z",
    transform: "translate(326.039 1387.656)",
    fill: "#0e182c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(2512.99 3267.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M2335.454,1772.336l44.081-66.526a4.268,4.268,0,0,1,3.457-2.161h163.651c.653,0,1.182-.8,1.182-1.784h0c0-.985-.53-1.784-1.182-1.784h-164.63a4.267,4.267,0,0,0-3.457,2.161l-44.773,67.572a2.472,2.472,0,0,0,0,2.523h0A.93.93,0,0,0,2335.454,1772.336Z",
    transform: "translate(-2333.436 -1700.081)",
    fill: "#a5b1ba"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(2124.114 3383.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245-2",
    "data-name": "Path 245",
    d: "M2545.807,1772.336l-44.081-66.526a4.268,4.268,0,0,0-3.457-2.161H2334.618c-.653,0-1.182-.8-1.182-1.784h0c0-.985.529-1.784,1.182-1.784h164.631a4.268,4.268,0,0,1,3.457,2.161l44.773,67.572a2.514,2.514,0,0,1,.294,2.523h0A1.186,1.186,0,0,1,2545.807,1772.336Z",
    transform: "translate(-2333.436 -1700.081)",
    fill: "#a5b1ba"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(2266.443 3179.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M675.432,1433.927s.036,1.658,1.589,1.626,1.158-1.626,1.158-1.626l-9.381-84.688-166.486.279v3.047H666.43Z",
    transform: "translate(-502.312 -1349.239)",
    fill: "#a5b1ba"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1397.445,1761.022Zm-4.136-15.748a7.958,7.958,0,1,0,2.33,5.626,7.93,7.93,0,0,0-2.33-5.626Zm-1.719-7.886a14.036,14.036,0,0,1,5.854,3.391.489.489,0,0,0,.583.07l3.7-2.134.02-.012a.922.922,0,0,1,1.231.348l.016.026,2.6,4.505a.923.923,0,0,1-.336,1.253l-.025.015-3.667,2.117a.489.489,0,0,0-.23.539h0a13.986,13.986,0,0,1,.309,1.681,14.157,14.157,0,0,1-.309,5.108.487.487,0,0,0,.258.555l3.666,2.116h0a.924.924,0,0,1,.336,1.253l-2.616,4.531h0a.923.923,0,0,1-1.251.335l-.027-.015-3.672-2.12a.489.489,0,0,0-.581.072,14.04,14.04,0,0,1-5.874,3.4.488.488,0,0,0-.355.47v4.264a.919.919,0,0,1-.916.915h-5.233a.918.918,0,0,1-.915-.915v-4.264a.489.489,0,0,0-.376-.476,14.051,14.051,0,0,1-5.854-3.39.487.487,0,0,0-.607-.057l-3.672,2.121a.925.925,0,0,1-1.252-.337l-.016-.026-2.6-4.506h0a.922.922,0,0,1,.334-1.25l3.693-2.132a.488.488,0,0,0,.23-.539h0a13.991,13.991,0,0,1-.309-1.682,14.255,14.255,0,0,1,0-3.428,13.938,13.938,0,0,1,.309-1.681.489.489,0,0,0-.258-.555l-3.667-2.117a.922.922,0,0,1-.334-1.251l.014-.027,2.6-4.505h0a.922.922,0,0,1,1.251-.337h0l3.7,2.134a.486.486,0,0,0,.593-.082,14.167,14.167,0,0,1,2.725-2.052,13.989,13.989,0,0,1,3.138-1.333.49.49,0,0,0,.356-.471v-4.265a.918.918,0,0,1,.915-.914h5.233a.919.919,0,0,1,.916.914v4.265A.488.488,0,0,0,1391.59,1737.388Z",
    transform: "translate(939.02 1506.431)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M2502.81,1446.744a1.365,1.365,0,0,1,2.729,0v3.209h3.209a1.365,1.365,0,0,1,0,2.73h-3.209v3.208a1.365,1.365,0,1,1-2.729,0v-3.208H2499.6a1.365,1.365,0,0,1,0-2.73h3.209Z",
    transform: "translate(178.925 1845.73)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M2687.145,1882.388a1.365,1.365,0,0,1,2.73,0v3.208h3.208a1.365,1.365,0,0,1,0,2.73h-3.208v3.208a1.365,1.365,0,0,1-2.73,0v-3.208h-3.208a1.365,1.365,0,0,1,0-2.73h3.208Z",
    transform: "translate(-346.587 1437.245)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M2687.145,1882.388a1.365,1.365,0,0,1,2.73,0v3.208h3.208a1.365,1.365,0,0,1,0,2.73h-3.208v3.208a1.365,1.365,0,0,1-2.73,0v-3.208h-3.208a1.365,1.365,0,0,1,0-2.73h3.208Z",
    transform: "translate(-538.873 1615.181)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M2834.92,1982.116a1.364,1.364,0,1,1,2.728,0v3.208h3.209a1.364,1.364,0,0,1,0,2.728h-3.209v3.209a1.364,1.364,0,1,1-2.728,0v-3.209h-3.209a1.364,1.364,0,1,1,0-2.728h3.209Z",
    transform: "translate(-467.625 1355.56)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M2837.33,1982.835a2.083,2.083,0,1,1,4.166,0v4.9h4.9a2.083,2.083,0,0,1,0,4.166h-4.9v4.9a2.083,2.083,0,1,1-4.166,0v-4.9h-4.9a2.083,2.083,0,1,1,0-4.166h4.9Z",
    transform: "translate(-698.655 1487.577)",
    fill: "#c2d0db",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    d: "M16.637,0H147.392a16.637,16.637,0,0,1,16.637,16.637v93.5a16.636,16.636,0,0,1-16.636,16.636H16.637A16.637,16.637,0,0,1,0,110.136v-93.5A16.637,16.637,0,0,1,16.637,0Z",
    transform: "translate(2563.465 3130.428)",
    fill: "#ff4f78"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    d: "M16.637,0H147.392a16.637,16.637,0,0,1,16.637,16.637v93.5a16.636,16.636,0,0,1-16.636,16.636H16.637A16.637,16.637,0,0,1,0,110.136v-93.5A16.637,16.637,0,0,1,16.637,0Z",
    transform: "translate(2124.365 3247.377)",
    fill: "#40cecf"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    d: "M16.637,0H147.392a16.637,16.637,0,0,1,16.637,16.637v93.5a16.636,16.636,0,0,1-16.636,16.636H16.637A16.637,16.637,0,0,1,0,110.136v-93.5A16.637,16.637,0,0,1,16.637,0Z",
    transform: "translate(2265.709 3042.177)",
    fill: "#5846f5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    d: "M12.681,0H151.348a12.681,12.681,0,0,1,12.681,12.681v6.845a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V12.681A12.681,12.681,0,0,1,12.681,0Z",
    transform: "translate(2563.465 3130.428)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    d: "M12.681,0H151.348a12.681,12.681,0,0,1,12.681,12.681v6.845a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V12.681A12.681,12.681,0,0,1,12.681,0Z",
    transform: "translate(2124.365 3247.377)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    d: "M12.681,0H151.348a12.681,12.681,0,0,1,12.681,12.681v6.845a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V12.681A12.681,12.681,0,0,1,12.681,0Z",
    transform: "translate(2265.709 3042.177)",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M3372.1,1201.935a2.788,2.788,0,1,0-2.788,2.787A2.788,2.788,0,0,0,3372.1,1201.935Z",
    transform: "translate(-677.682 1938.255)",
    fill: "#f7622a"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M3372.1,1201.935a2.788,2.788,0,1,0-2.788,2.787A2.788,2.788,0,0,0,3372.1,1201.935Z",
    transform: "translate(-1116.782 2055.205)",
    fill: "#f7622a"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M3372.1,1201.935a2.788,2.788,0,1,0-2.788,2.787A2.788,2.788,0,0,0,3372.1,1201.935Z",
    transform: "translate(-975.437 1850.005)",
    fill: "#f7622a"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M3410.516,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3410.516,1201.935Z",
    transform: "translate(-705.541 1938.255)",
    fill: "#22a851"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M3410.516,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3410.516,1201.935Z",
    transform: "translate(-1144.641 2055.205)",
    fill: "#22a851"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M3410.516,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3410.516,1201.935Z",
    transform: "translate(-1003.297 1850.005)",
    fill: "#22a851"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M3448.931,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3448.931,1201.935Z",
    transform: "translate(-733.401 1938.255)",
    fill: "#fcd740"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M3448.931,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3448.931,1201.935Z",
    transform: "translate(-1172.501 2055.205)",
    fill: "#fcd740"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M3448.931,1201.935a2.787,2.787,0,1,0-2.787,2.787A2.787,2.787,0,0,0,3448.931,1201.935Z",
    transform: "translate(-1031.156 1850.005)",
    fill: "#fcd740"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(2168.188 3447.286)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 84.48,
    height: 110.192,
    transform: "translate(84.48 110.192) rotate(180)",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 73.525,
    height: 14.669,
    transform: "translate(79.203 22.593) rotate(180)",
    fill: "#c2d0db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 30.263,
    height: 71.901,
    transform: "translate(79.203 100.18) rotate(180)",
    fill: "#c2d0db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 37.641,
    height: 8.327,
    transform: "translate(43.319 36.607) rotate(180)",
    fill: "#c2d0db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 37.641,
    height: 8.327,
    transform: "translate(43.319 51.002) rotate(180)",
    fill: "#c2d0db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 37.641,
    height: 8.327,
    transform: "translate(43.319 65.397) rotate(180)",
    fill: "#c2d0db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 37.641,
    height: 28.716,
    transform: "translate(43.319 100.18) rotate(180)",
    fill: "#c2d0db"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(2258.273 3476.158)"
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M1256.147,2647.776a12.479,12.479,0,0,0-1.353.181l-1.382-.21-.1-.017v21.763s10,2.135,12.068-11.048C1267.019,2647.962,1259.349,2647.519,1256.147,2647.776Zm-1.3,4.841a5.348,5.348,0,0,0,1.33.041c1.569-.158,5.833-.088,4.952,5.542-1.073,6.86-6.282,5.745-6.282,5.745Z",
    transform: "translate(-1206.018 -2552.108)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1242.943,2647.615a13.991,13.991,0,0,0-2.736-.029c-.035,0-.07.006-.1.006a13.107,13.107,0,0,0-1.429.2l-1.487-.228v21.763a9.807,9.807,0,0,0,2.916-.005c3.191-.449,9.2-1.435,10.546-10.05C1251.9,2651.266,1246.478,2648.017,1242.943,2647.615Zm4.982,10.423c-1.073,6.86-6.282,5.746-6.282,5.746v-.379a5.128,5.128,0,0,1-2.917.379v-11.328a5.359,5.359,0,0,0,1.33.041,7.248,7.248,0,0,1,1.587.011v-.052a5.359,5.359,0,0,0,1.33.041C1244.541,2652.339,1248.805,2652.409,1247.925,2658.038Z",
    transform: "translate(-1192.814 -2551.948)",
    fill: "#eaeaea"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M1041.526,2587.338c0,1.137-6.545,2.117-15.749,2.5-2.66.111-5.542.169-8.551.169-13.416,0-24.294-1.2-24.294-2.666s10.879-2.671,24.294-2.671S1041.526,2585.863,1041.526,2587.338Z",
    transform: "translate(-992.75 -2500.456)",
    fill: "#a06933"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M1008.826,2209.037s-18.666-4.667-15.166-16.332,16.332-11.666,12.249-35-1.167-26.249,16.916-38.5c0,0-14.582,20.415,0,36.165s-2.924,30.185-5.25,36.165c-4.083,10.5,6.124,17.11,6.124,17.11Z",
    transform: "translate(-992.989 -2119.209)",
    opacity: 0.9,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M1136.645,2372.765s7.346-2.455,5.968-8.591-14.508-10.226-5.078-18.241c11.666-9.916.117-20.389-7-26.832,0,0,7,12.249-4.083,26.832-6.1,8.023,5.834,14.483,6.749,17.628a8.936,8.936,0,0,1-2.41,9Z",
    transform: "translate(-1100.7 -2282.937)",
    opacity: 0.9,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1040.707,2599.433v24.329a13.5,13.5,0,0,1-13.5,13.509h-21.769a13.5,13.5,0,0,1-13.5-13.509v-24.329h.181c0,1.47,10.879,2.666,24.294,2.666,3.01,0,5.891-.058,8.551-.169C1034.162,2601.55,1040.707,2600.57,1040.707,2599.433Z",
    transform: "translate(-991.931 -2512.551)",
    fill: "#3b2bc9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M1024.958,2601.929v21.833a13.5,13.5,0,0,1-13.5,13.509h-6.02a13.5,13.5,0,0,1-13.5-13.509v-24.329h.181c0,1.47,10.879,2.666,24.294,2.666C1019.416,2602.1,1022.3,2602.041,1024.958,2601.929Z",
    transform: "translate(-991.931 -2512.551)",
    fill: "#5846f5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(2449.564 3164.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(23.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1909.637,711.792a17.441,17.441,0,0,1,24.211,10.992L1966,720.3a49.474,49.474,0,0,0-74.552-35.044Z",
    transform: "translate(-1891.447 -678.1)",
    fill: "#62d3bd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(61.656 49.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M2105.619,952.049a17.422,17.422,0,0,1-5.112,10.318l18.2,26.561a49.425,49.425,0,0,0,19.061-39.367Z",
    transform: "translate(-2100.507 -949.561)",
    fill: "#62d3bd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(0 11.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M1815.556,794.32a17.433,17.433,0,0,1-19.37-27.843l-18.293-26.692a49.467,49.467,0,0,0,55.936,81.2Z",
    transform: "translate(-1759.725 -739.786)",
    fill: "#62d3bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(23.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1909.637,711.792a17.441,17.441,0,0,1,24.211,10.992L1966,720.3a49.474,49.474,0,0,0-74.552-35.044Z",
    transform: "translate(-1891.447 -678.1)",
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(61.656 49.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M2105.619,952.049a17.422,17.422,0,0,1-5.112,10.318l18.2,26.561a49.425,49.425,0,0,0,19.061-39.367Z",
    transform: "translate(-2100.507 -949.561)",
    fill: "#e7eff6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 11.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1815.556,794.32a17.433,17.433,0,0,1-19.37-27.843l-18.293-26.692a49.467,49.467,0,0,0,55.936,81.2Z",
    transform: "translate(-1759.725 -739.786)",
    fill: "#a5b1ba"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 99.439,
    height: 4.972,
    transform: "translate(2124.046 3423.521)",
    fill: "#a5b1ba"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 79.551,
    height: 4.972,
    transform: "translate(2124.046 3412.673)",
    fill: "#a5b1ba"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 79.551,
    height: 4.972,
    transform: "translate(2124.046 3401.825)",
    fill: "#a5b1ba"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(2680.621 3331.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    d: "M4.909,0H64.224a4.909,4.909,0,0,1,4.909,4.909V40.5a4.908,4.908,0,0,1-4.908,4.908H4.908A4.908,4.908,0,0,1,0,40.5V4.909A4.909,4.909,0,0,1,4.909,0Z",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M2039.93,1315.847h-.134a1.82,1.82,0,0,1-.883-.229l-26.648-14.8a1.817,1.817,0,1,1,1.765-3.176l25.833,14.352,25.833-14.352a1.817,1.817,0,1,1,1.765,3.176l-26.648,14.8A1.821,1.821,0,0,1,2039.93,1315.847Z",
    transform: "translate(-2005.297 -1293.492)",
    fill: "#c2d0db"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(2492.604 3043.637)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(0 41.214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 9.751,
    height: 23.427,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(12.026 31.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 9.751,
    height: 33.339,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(24.052 21.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 9.751,
    height: 42.73,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(36.078 29.736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 9.751,
    height: 34.905,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(48.104 25.563)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 9.751,
    height: 39.078,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(60.13 16.693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 9.751,
    height: 47.948,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(72.156 8.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 9.751,
    height: 56.294,
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(84.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 9.751,
    height: 64.641,
    fill: "#c2d0db"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(2487.373 3027.382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 108.732,
    height: 2.61,
    rx: 1.305,
    transform: "translate(0 86.116)",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 2.175,
    height: 87.421,
    rx: 1.087,
    transform: "translate(103.513)",
    fill: "#e7eff6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(2568.372 3106.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(0 34.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M2819.024,1089.945l-10.612-17.434s-2.274-1.9-1.516,1.516,5.306,10.991,5.306,10.991l-2.353-.882a1.458,1.458,0,0,0-1.32.152c-.55.365-1.254.878-1.254,1.109v1.319a1.017,1.017,0,0,1-.494.872l-.752.451a1.337,1.337,0,0,0-.649,1.147v.49a1.047,1.047,0,0,1-.579.937l-.209.1a1.665,1.665,0,0,0-.888,1.163l-.154.77a1.66,1.66,0,0,0,0,.653l.463,2.318a2.158,2.158,0,0,0,1.314,1.58l.81.324,3.587,8.151a3.539,3.539,0,0,0,1.925,1.861l6.237,2.495,4.927-4.169Z",
    transform: "translate(-2803.518 -1071.986)",
    fill: "#e49f79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M2907.226,1273.055l-8.338-10.991-6.822,7.2,8.338,18.192Z",
    transform: "translate(-2877.697 -1231.22)",
    fill: "#e49f79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M2889.3,1145.468v-4.156q0-.391-.039-.781l-1.35-13.59a5.257,5.257,0,0,0-.75-2.191l-5.13-8.336a.651.651,0,0,0-.945-.188c-.865.669-1.99,2.666,1.012,8.4l.379,4.169s-3.411,6.064-2.653,9.1,5.685,8.338,5.685,8.338Z",
    transform: "translate(-2867.347 -1108.938)",
    fill: "#e49f79"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M2961.1,1280.749s-3.032.758-10.991,9.475-13.644,11.749-16.3,11.37-12.886-12.886-12.886-12.886l-12.507,11.37s5.306,31.836,22.361,34.868,32.215-5.685,32.215-5.685Z",
    transform: "translate(-2891.393 -1212.601)",
    fill: "#5141de"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M3096.682,929.881s-5.513,4.715-6.9,33.755C3088.7,986.5,3104.3,983.6,3104.3,975.614s-1.881-42.587-1.881-42.587Z",
    transform: "translate(-3043.287 -918.67)",
    fill: "#1d3151"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M3145.77,864.019s8.143-5.831,22.867-1.815c11.978,3.267,21.611,39.478,17.059,44.644-4.086,4.638-6.534,4.719-6.534,3.63,0,0-7.622,8.348-8.711,2.178,0,0,0,4.718-8.348,7.985-7.058,2.762-13.067,4.355-19.963,3.63S3131.977,871.641,3145.77,864.019Z",
    transform: "translate(-3082.211 -860.793)",
    fill: "#1d3151"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M3198.912,1192.9a16.69,16.69,0,0,0-5.394,12.09,9.705,9.705,0,0,0,1.569,5.195l2.194,3.413,5.685-8.717,1.535-10.248Z",
    transform: "translate(-3130.231 -1139.009)",
    fill: "#5141de"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M3221.713,1125.835l4.771,15.728,15.244-9.437-7.159-18.881S3224.564,1117.366,3221.713,1125.835Z",
    transform: "translate(-3153.851 -1072.279)",
    fill: "#e49f79"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(49.084 10.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M3109.059,934.508s-5.53,24.087,2.708,31.521a12.177,12.177,0,0,0,3.051,2c5.843,2.686,13.925,2.055,19.855-5.682,7.072-9.226,7.35-25,7.35-25l-14.209-12.361-.622.133-10.7,2.248Z",
    transform: "translate(-3107.04 -924.99)",
    fill: "#c6815b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M3108.014,935.193a89.36,89.36,0,0,0-1.6,9.857,68.262,68.262,0,0,0-.414,7.8c.048,5.894,1.409,10.876,4.724,13.867a12.171,12.171,0,0,0,3.052,2c5.727,1.87,13.7.213,19.164-6.925,7.072-9.225,12.325-22.4,12.325-22.4l-19.115-13.58-10.695,2.248Z",
    transform: "translate(-3105.995 -925.674)",
    fill: "#e49f79"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M3171.017,881.758a11.346,11.346,0,0,0,1.969.212s4.362-1.211,5,1.306-.155,16.143,13.337,21.419l0,.3.937,8.386s13.843-4.208,13.546-20.851-13.765-18.669-13.765-18.669-6.418-10.936-18.562-1.425C3164.732,879.284,3168.32,881.212,3171.017,881.758Z",
    transform: "translate(-3108.809 -867.293)",
    fill: "#1d3151"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M3099.953,884.892c.093,1.848,1.724,3.5,3.939,4.026a44.708,44.708,0,0,0,7.629,1.107c.637.037,1.218.058,1.734.068,1.273.025,2.221-.846,2.036-1.88a17.546,17.546,0,0,1-.224-2.447,26.159,26.159,0,0,1,1.96-10.623l2.277-5.6.3-.735s-.417-.173-1.126-.395c-.427-.129-.959-.277-1.571-.411-3.4-.759-9.276-1.166-13.082,3.537C3100.185,876.036,3099.782,881.554,3099.953,884.892Z",
    transform: "translate(-3051.822 -866.44)",
    fill: "#1d3151"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M3115.835,996.764a2.455,2.455,0,0,1-1.154-.2c-.4-.133-.8-.255-1.148-.347s-.762-.182-1.171-.26a2.449,2.449,0,0,1-1.1-.39c-.266-.227-.283-.684.207-1.111a3.285,3.285,0,0,1,4.739,1.241C3116.419,996.307,3116.178,996.7,3115.835,996.764Z",
    transform: "translate(-3061.167 -972.298)",
    fill: "#383b54"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M3106.126,1050.709a65.42,65.42,0,0,0-.4,7.479,9.32,9.32,0,0,0,.936-3.37A8.977,8.977,0,0,0,3106.126,1050.709Z",
    transform: "translate(-3056.686 -1019.891)",
    fill: "#f58b7b"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 6.791,
    cy: 6.187,
    rx: 6.791,
    ry: 6.187,
    transform: "matrix(0.543, -0.84, 0.84, 0.543, 60.364, 40.946)",
    fill: "#f58b7b"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M3133.935,1117.724s4.566,1.029,6.8.283c0,0-.964,5.781-3.213,4.9S3133.935,1117.724,3133.935,1117.724Z",
    transform: "translate(-3080.317 -1076.031)",
    fill: "#dd7262"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(61.01 29.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M3179.552,1044.712a1.3,1.3,0,1,0,1.621-1.245A1.465,1.465,0,0,0,3179.552,1044.712Z",
    transform: "translate(-3179.492 -1043.437)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M3192.933,1047.609a2.255,2.255,0,0,0,1.173-.513,4.635,4.635,0,0,1-.775.937C3192.994,1048.281,3192.933,1047.609,3192.933,1047.609Z",
    transform: "translate(-3190.752 -1046.502)",
    fill: "#1d3151"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(50.53 28.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M3117.847,1036.829c-.133.791-.693,1.386-1.252,1.329s-.9-.745-.772-1.536.693-1.386,1.251-1.329S3117.979,1036.037,3117.847,1036.829Z",
    transform: "translate(-3115.65 -1035.273)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M3115.594,1035.978a1.674,1.674,0,0,1-.69-.784,4.179,4.179,0,0,0,.254,1.024C3115.322,1036.529,3115.594,1035.978,3115.594,1035.978Z",
    transform: "translate(-3114.904 -1035.194)",
    fill: "#1d3151"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M3306.744,971.746s9.382-8.015,8.161-17.413C3314.905,954.333,3314.308,964.777,3306.744,971.746Z",
    transform: "translate(-3225.084 -939.154)",
    fill: "#16263e"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M3269.117,951.788s11.294-4.969,12.836-14.32C3281.953,937.468,3278.369,947.3,3269.117,951.788Z",
    transform: "translate(-3193.563 -925.026)",
    fill: "#16263e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M3186.875,930.688a11.35,11.35,0,0,0,1.969.212s4.362-1.211,5,1.306-.154,16.143,13.338,21.419l0,.3c1.167-.033.992-.474-1.743-1.634-9.729-4.128-8.327-18.487-10.491-22.9s-6.456-1.484-6.456-1.484Z",
    transform: "translate(-3124.667 -916.222)",
    opacity: 0.6,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M3164.6,890.185c.1.346.214.674.331.986.637.037,1.218.058,1.734.068,1.273.025,2.221-.846,2.036-1.88a17.58,17.58,0,0,1-.225-2.447,26.163,26.163,0,0,1,1.96-10.623l2.586-6.391c-.285-.457-.871-.05-1.135-.341-.594-.651-1.123-.856-1.549-.431l-.022.021A20.56,20.56,0,0,0,3164.6,890.185Z",
    transform: "translate(-3105.23 -867.587)",
    fill: "#16263e",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(46.511 25.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(10.568 0.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M3167.309,1029.8a6.225,6.225,0,0,1-1.536,4.208,7.228,7.228,0,0,1-6.39,2.083c-2.492-.289-3.582-2.655-3.567-4.934a4.59,4.59,0,0,1,3.639-4.76c2.66-.652,7.574-.168,7.854,3.4.028.35.577.353.549,0-.246-3.142-3.884-4.357-6.575-4.207-2.753.153-5.336,1.287-5.889,4.229-.407,2.166.094,4.922,2.078,6.188a6.54,6.54,0,0,0,4.244.618,7.206,7.206,0,0,0,3.487-1.344,6.767,6.767,0,0,0,2.655-5.484C3167.845,1029.448,3167.3,1029.446,3167.309,1029.8Z",
    transform: "translate(-3155.263 -1025.581)",
    fill: "#0e182c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M3090.406,1023.328c-.83,2.682.176,8.742,4.234,7,1.744-.75,2.6-2.742,3.166-4.429a4.1,4.1,0,0,0-1.889-4.9,3.822,3.822,0,0,0-5.511,2.335c-.119.333.411.477.529.146a3.324,3.324,0,0,1,2.891-2.422,3.51,3.51,0,0,1,3.089,1.6c1.146,1.761.28,3.937-.747,5.551-1.051,1.651-3.543,2.815-4.73.656a7.5,7.5,0,0,1-.5-5.381C3091.039,1023.136,3090.51,1022.991,3090.406,1023.328Z",
    transform: "translate(-3090.137 -1020.503)",
    fill: "#0e182c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(7.24 4.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M3138.549,1047.453c-.894-1.234-2.514-2.19-3.723-.787-.229.266.157.656.388.388.954-1.107,2.169-.279,2.861.676.205.283.681.01.474-.277Z",
    transform: "translate(-3134.756 -1045.971)",
    fill: "#0e182c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(22.6 4.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M3229.6,1050.3l11.34,2.926a.275.275,0,0,0,.146-.529l-11.34-2.926a.275.275,0,0,0-.146.529Z",
    transform: "translate(-3229.407 -1049.76)",
    fill: "#0e182c"
  })))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M3289.022,1052.42s2.634-4.46,6.706-1.98,2.385,9.805-1.709,12.57-6.851-1.7-6.851-1.7Z",
    transform: "translate(-3208.684 -1019.037)",
    fill: "#e49f79"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M3306.71,1080.465a.56.56,0,0,1-.352-.235l-1.911-2.767,3.927-3.2a.556.556,0,0,1,.822.112.669.669,0,0,1-.128.886l-2.98,2.43,1.222,1.771a.668.668,0,0,1-.13.885A.565.565,0,0,1,3306.71,1080.465Z",
    transform: "translate(-3223.159 -1039.509)",
    fill: "#c6815b"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M3198.935,1218.614s15.059.987,29.84,24.106,17.769,48.837,4.548,54.2c-14.023,5.685-40.553,7.2-45.479.379s-14.781-26.151-13.644-37.142a203.642,203.642,0,0,1,3.578-20.137,22.867,22.867,0,0,1,10.126-14.437Z",
    transform: "translate(-3113.972 -1160.549)",
    fill: "#5846f5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M3235.143,1161.366c-3.825,2.14-22.293,11.91-15.152,23.463l19.708-13.265-3.5-9.8A.737.737,0,0,0,3235.143,1161.366Z",
    transform: "translate(-3151.047 -1112.512)",
    fill: "#5846f5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M3236.3,992.369l6.494-3.374a.424.424,0,0,1,.5.674l-5.821,5.88A2.019,2.019,0,0,1,3236.3,992.369Z",
    transform: "translate(-3165.742 -968.147)",
    fill: "#ff4f78"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M3124.69,1057.333c.022.01.046.019.069.027l.914.315a.216.216,0,0,0,.255-.153.2.2,0,0,0-.1-.275l-.914-.315a.892.892,0,0,1-.542-.689,2.165,2.165,0,0,1,.11-1.236l.047-.127c.125-.334.393-.55.6-.479a1.069,1.069,0,0,0,.986-.216,2.246,2.246,0,0,0,.737-1.024l.664-1.809a.211.211,0,0,0-.1-.274.217.217,0,0,0-.255.155l-.664,1.808a1.712,1.712,0,0,1-.557.78.714.714,0,0,1-.654.152c-.4-.137-.9.215-1.11.786l-.047.126a2.681,2.681,0,0,0-.132,1.534A1.255,1.255,0,0,0,3124.69,1057.333Z",
    transform: "translate(-3071.947 -1020.193)",
    fill: "#c6815b"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M3177.932,1002.877a5.16,5.16,0,0,1-1.722.241c-.619.02-1.24.052-1.78.1s-1.16.111-1.774.19a5.121,5.121,0,0,1-1.735.037c-.476-.121-.7-.559-.2-1.161a5.435,5.435,0,0,1,3.563-1.431,5.246,5.246,0,0,1,3.7.847C3178.558,1002.211,3178.389,1002.681,3177.932,1002.877Z",
    transform: "translate(-3110.897 -978.101)",
    fill: "#383b54"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M3330.594,1542.33l-20.466,12.128,4.927,8.717,25.772-7.959Z",
    transform: "translate(-3227.919 -1431.734)",
    fill: "#e49f79"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M3392.28,1324.031a49.524,49.524,0,0,1-19.583,9.907,41.581,41.581,0,0,1-5.431,1.084l-11.294-12.624a.365.365,0,0,1-.038-.038l-1.531-1.713-.019-.019a.012.012,0,0,1,0-.008s9.1-8.717,19.708-13.265l-24.256-34.11s9.475-5.306,16.3,0S3403.271,1314.556,3392.28,1324.031Z",
    transform: "translate(-3261.181 -1204.34)",
    fill: "#5846f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M3406.163,1599.425l-1.77.432a41.536,41.536,0,0,1-5.431,1.084l-11.294-12.624C3390.484,1591.258,3397.75,1597.132,3406.163,1599.425Z",
    transform: "translate(-3292.876 -1470.259)",
    fill: "#3b2bc9",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M3380.2,1437.23l12.984,10.82a.716.716,0,0,1,0,1.1l-12.984,10.82,9.242-11.091a.435.435,0,0,0,0-.558Z",
    transform: "translate(-3286.616 -1343.69)",
    fill: "#3b2bc9",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(29.281 95.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M3029.6,1503.955a26.881,26.881,0,0,1-7.271,1.744,75.9,75.9,0,0,1-15.463-.105,2.673,2.673,0,0,1-.589-.133h0a2.666,2.666,0,0,1-.628-.3l-7.252-4.712c.39-12.483.78-22.625.78-22.625l-15.214-27.7,11.313,6.632,17.823,2.711.121.019a64.836,64.836,0,0,0,10.923,20.285Z",
    transform: "translate(-2983.959 -1450.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M3108.139,1552.186a26.89,26.89,0,0,1-7.271,1.744l-16.052-.238h0l-.858-23.351-6.242-4.291,6.242,1.95,16.384-.909c-5.789-9.549-8.009-16.719-8.7-19.4l.121.019A64.829,64.829,0,0,0,3102.678,1528Z",
    transform: "translate(-3062.498 -1498.354)",
    fill: "#e9eeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M3067.453,1528.881l.39-.39s-8.582-15.994-9.362-20.675c0,0,7.068,15.266,12.9,21.676Z",
    transform: "translate(-3046.388 -1498.454)",
    fill: "#e9eeff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(49.936 116.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M3149.81,1591.881l-15.409,7.2a120.445,120.445,0,0,1-12.027-1.689l0,0a5.2,5.2,0,0,1-1.615-.581c-1.514-1.135-1.135-2.274-1.135-2.274l-3.792-3.409-2.185-4.369-.09-.18s-3.788-3.031-1.662-3.148,5.832,2.391,5.832,2.391h12.128l-4.935-8.289,6.831,2.224,10.989,3.792h3.031Z",
    transform: "translate(-3111.245 -1577.53)",
    fill: "#e49f79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M3134.758,1645.017a5.2,5.2,0,0,1-1.615-.581c-1.514-1.135-1.135-2.274-1.135-2.274l-3.792-3.409-2.185-4.369,6.2,3.647,1.56.78a7.754,7.754,0,0,0,0,3.121C3134.172,1643.066,3134.726,1644.9,3134.758,1645.017Z",
    transform: "translate(-3123.632 -1625.157)",
    fill: "#e49f79"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M3241.706,1236.075s10.057-9.586,17.469-11.926C3259.175,1224.148,3249.983,1223.816,3241.706,1236.075Z",
    transform: "translate(-3170.6 -1165.185)",
    fill: "#3b2bc9",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M113.7,211.336a45.215,45.215,0,0,0-3.338,5.684,73.311,73.311,0,0,0-2.9,7.054h58.014a51.167,51.167,0,0,0-3.109-9.572,47.86,47.86,0,0,0-5.143-8.415Z",
    transform: "translate(-38.31 -73.465)",
    fill: "#40cecf"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(2676.017 3065.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M3495.179,682.627V704.9a6.179,6.179,0,0,0,6.18,6.18h8.411l-3.719,11.465,16.071-11.465h22.112a6.179,6.179,0,0,0,6.18-6.18V682.627a6.179,6.179,0,0,0-6.18-6.18H3501.36A6.179,6.179,0,0,0,3495.179,682.627Z",
    transform: "translate(-3495.179 -676.447)",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(12.137 15.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    fill: "#a5b1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    transform: "translate(12.763)",
    fill: "#a5b1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    transform: "translate(25.712)",
    fill: "#a5b1ba"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(2351.714 2984.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505-2",
    "data-name": "Group 505",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387-2",
    "data-name": "Path 387",
    d: "M3495.179,682.627V704.9a6.179,6.179,0,0,0,6.18,6.18h8.411l-3.719,11.465,16.071-11.465h22.112a6.179,6.179,0,0,0,6.18-6.18V682.627a6.179,6.179,0,0,0-6.18-6.18H3501.36A6.179,6.179,0,0,0,3495.179,682.627Z",
    transform: "translate(-3495.179 -676.447)",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504-2",
    "data-name": "Group 504",
    transform: "translate(12.137 15.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38-2",
    "data-name": "Ellipse 38",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    fill: "#a5b1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39-2",
    "data-name": "Ellipse 39",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    transform: "translate(12.763)",
    fill: "#a5b1ba"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40-2",
    "data-name": "Ellipse 40",
    cx: 2.31,
    cy: 2.31,
    r: 2.31,
    transform: "translate(25.712)",
    fill: "#a5b1ba"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(2131.813 3213.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(83.892 127.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M3002.171,1830.317l10.749,18.471h10.638l10.861-12.65-2.732-6.206v0l-2.195-4.984-5.935,1.169Z",
    transform: "translate(-3002.171 -1824.944)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M3016.6,1826.113c.336,2.731,6.306,13.308,6.306,13.308l1.823-9.488v0l-2.194-4.984Z",
    transform: "translate(-2995.21 -1824.944)",
    fill: "#f4a984"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M3157.789,1491.493l5.146-2.32,1.573,2.32.522,2.761Z",
    transform: "translate(-3078.362 -1425.134)",
    fill: "#f27b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M3157.9,1399.88l-1.53,12.262,3.427,2.537,3.182,8.06-18.737,15.075-9.039-24.927,1.275-4.478s2.838-9.553,3.636-14.478c.791-4.878,8.976-1.277,8.976-1.277Z",
    transform: "translate(-3072.039 -1345.859)",
    fill: "#f9af8a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(52.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M3149.3,1177.547l29.611-12.332s3.144-5.017.949-10.093-11.454-5.739-14.882-.155c-.374.614-.685,1.143-.953,1.613v-.012s-1.766-2.974-6.254-.456-6.489,9.325-6.489,9.325C3145.372,1170.157,3149.3,1177.547,3149.3,1177.547Z",
    transform: "translate(-3145.024 -1151.04)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M3273.24,1339.661a6.726,6.726,0,0,0,4.264,7.179c5.074,1.98,5.325.369,5.325.369l-2.428-3.245Z",
    transform: "translate(-3270.916 -1303.938)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M3115.6,1232.086l3.772,11.55-7.3-6.15Z",
    transform: "translate(-3076.941 -1216.737)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M3276,1281.872s-6.721-.579-6.226,5.883,10.832,11.622,10.832,11.622l1.708-2.228Z",
    transform: "translate(-3269.749 -1257.083)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M3120.869,1259.258c-2.108,10-20.106,16.357-31.7-2.854-10.157-16.827-5.311-29.533,4.809-30.552s16.824,2.42,16.824,2.42,2.6,4.7,5.026,10.431a69.455,69.455,0,0,1,3.236,9.175C3119.982,1251.394,3121.755,1255.057,3120.869,1259.258Z",
    transform: "translate(-3073.281 -1211.531)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M3243.871,1350.635s-3.2-3.158-6.138-.063.229,9.031,4.415,10.463,5.525-3.068,5.525-3.068Z",
    transform: "translate(-3228.826 -1311.68)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M3149.41,1233.113s-3.265-10.141-1.861-10.126,27.862-5.889,25.7-14.334-10.9-5.166-10.9-5.166S3129.987,1210.453,3149.41,1233.113Z",
    transform: "translate(-3136.845 -1193.047)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M3119.737,1192.412s7.721-5.678,9.545.2c2.446,7.886-9.682,13.054-9.682,13.054Z",
    transform: "translate(-3088.606 -1182.579)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M3125.51,1325.584q-.059.027-.122.051l-1.613.627a.333.333,0,1,1-.242-.621l1.613-.627a1.72,1.72,0,0,0,1-1.131,2.778,2.778,0,0,0-.089-1.851l-.071-.183a.855.855,0,0,0-1-.625,1.952,1.952,0,0,1-1.695-.163,2.789,2.789,0,0,1-1.2-1.426l-1-2.624a.345.345,0,0,1,.192-.43.333.333,0,0,1,.43.192l1,2.622a2.123,2.123,0,0,0,.9,1.087,1.3,1.3,0,0,0,1.124.121,1.508,1.508,0,0,1,1.863,1l.072.183a3.449,3.449,0,0,1,.1,2.3A2.407,2.407,0,0,1,3125.51,1325.584Z",
    transform: "translate(-3086.207 -1285.211)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M3172.976,1320.7a1.345,1.345,0,1,1-1.805-1.1A1.518,1.518,0,0,1,3172.976,1320.7Z",
    transform: "translate(-3141.724 -1287.626)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 5.756,
    cy: 5.755,
    rx: 5.756,
    ry: 5.755,
    transform: "translate(16.208 35.11)",
    fill: "#fca286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M3098.849,1303.688a5.752,5.752,0,0,1-3.235-9.175A69.488,69.488,0,0,1,3098.849,1303.688Z",
    transform: "translate(-3053.07 -1267.341)",
    fill: "#fca286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M3264.123,1287.579s-2.54,6.2,1.7,14.64l-5.677-9.3.532-8.664Z",
    transform: "translate(-3251.439 -1259.022)",
    fill: "#703127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M3263.384,1381.268a.39.39,0,0,0,.193-.221l.779-2.2-3.212-1.433a.385.385,0,0,0-.53.224.464.464,0,0,0,.246.57l2.437,1.088-.5,1.408a.462.462,0,0,0,.248.569A.393.393,0,0,0,3263.384,1381.268Z",
    transform: "translate(-3250.057 -1334.511)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M3199.972,1210.927a7.126,7.126,0,0,1-.077-.9,8.561,8.561,0,0,1,.014-.9,7.74,7.74,0,0,1,.311-1.76,5.8,5.8,0,0,1,.746-1.589,5.263,5.263,0,0,1,1.2-1.251,6.259,6.259,0,0,1,1.53-.819,8.274,8.274,0,0,1,.836-.262c.3-.077.592-.155.886-.239a34.211,34.211,0,0,0,3.471-1.2,24.219,24.219,0,0,0,6.341-3.7,11.324,11.324,0,0,0,2.444-2.767,6.293,6.293,0,0,0,.712-1.709,4.421,4.421,0,0,0,.064-1.827,4.674,4.674,0,0,1-.244,1.776,6.3,6.3,0,0,1-.812,1.582,11.856,11.856,0,0,1-2.5,2.538,22.51,22.51,0,0,1-3.013,1.946,31.236,31.236,0,0,1-3.252,1.542c-1.109.463-2.245.86-3.395,1.214-.287.09-.576.174-.866.257a8.954,8.954,0,0,0-.892.3,6.3,6.3,0,0,0-1.635.954,5.457,5.457,0,0,0-1.244,1.426,6.059,6.059,0,0,0-.694,1.738,7.6,7.6,0,0,0-.181,1.839A7.753,7.753,0,0,0,3199.972,1210.927Z",
    transform: "translate(-3192.687 -1184.243)",
    fill: "#511e19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M3187.172,1215.444a4.005,4.005,0,0,1,.3-.847,5.875,5.875,0,0,1,.434-.781,7.65,7.65,0,0,1,1.14-1.358,10.843,10.843,0,0,1,2.944-1.942,17.721,17.721,0,0,1,3.361-1.135q.865-.208,1.747-.355l.9-.159c.3-.068.6-.12.9-.2a14.586,14.586,0,0,0,3.439-1.324,10.076,10.076,0,0,0,2.876-2.322,8.307,8.307,0,0,0,1.7-3.26,8.432,8.432,0,0,0,.127-3.624,9.246,9.246,0,0,1-.442,3.531,8.386,8.386,0,0,1-1.778,3.01,10.074,10.074,0,0,1-2.785,2.108,14.309,14.309,0,0,1-3.3,1.231c-.284.08-.576.133-.864.2l-.88.163c-.6.108-1.2.227-1.79.385a16.612,16.612,0,0,0-3.437,1.28,11.777,11.777,0,0,0-1.572.959,9.756,9.756,0,0,0-1.377,1.222,7.475,7.475,0,0,0-1.065,1.494A4.861,4.861,0,0,0,3187.172,1215.444Z",
    transform: "translate(-3178.969 -1189.218)",
    fill: "#511e19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M3296.05,1296.172a3.8,3.8,0,0,0-1.088.977,3.257,3.257,0,0,0-.618,1.384,3.084,3.084,0,0,0,.124,1.551,3.846,3.846,0,0,0,.325.7,5.847,5.847,0,0,0,.425.621,26.987,26.987,0,0,0,1.873,2.187,7.77,7.77,0,0,1,.875,1.077,2.388,2.388,0,0,1,.36,1.32,2.159,2.159,0,0,0-.066-1.465,5.919,5.919,0,0,0-.767-1.264l-1.742-2.258a5.573,5.573,0,0,1-.392-.555,3.758,3.758,0,0,1-.3-.583,2.819,2.819,0,0,1-.2-1.266A4.213,4.213,0,0,1,3296.05,1296.172Z",
    transform: "translate(-3290.506 -1268.686)",
    fill: "#59211b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(24.006 20.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0 9.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M3170.656,1309.162a6.513,6.513,0,0,0,1.64-.357c.571-.174,1.148-.34,1.654-.474s1.091-.276,1.674-.408a6.432,6.432,0,0,0,1.6-.5c.4-.228.491-.6-.134-.859a6.4,6.4,0,0,0-3.644.1,6.084,6.084,0,0,0-3.155,1.7C3169.9,1308.894,3170.185,1309.166,3170.656,1309.162Z",
    transform: "translate(-3170.108 -1306.35)",
    fill: "#511c17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 12.381, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M.716,4.541a4.434,4.434,0,0,0,1.207-.848c.4-.345.8-.684,1.16-.969s.783-.6,1.21-.909a4.4,4.4,0,0,0,1.1-.98c.227-.349.115-.746-.542-.822A4.657,4.657,0,0,0,1.818,1.2,4.486,4.486,0,0,0,.006,3.851C-.053,4.5.32,4.685.716,4.541Z",
    fill: "#511c17"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M3123.665,1300.169a1.345,1.345,0,1,1-1.719-1.231A1.516,1.516,0,0,1,3123.665,1300.169Z",
    transform: "translate(-3083.025 -1270.894)",
    fill: "#383b54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 1.944,
    cy: 1.465,
    rx: 1.944,
    ry: 1.465,
    transform: "translate(38.54 47.799) rotate(-106.688)",
    fill: "#ff806d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M2998.294,1540.339c-1.2,29.406,41.979,28.34,41.979,28.34h55.035s-11.445-17.181-10.208-27.028a44.553,44.553,0,0,0,6.391-.524c1.048-.161,2.078-.358,3.077-.578,11.986-2.66,13.459-8.571,13.459-8.571-4.479-11.938-13.737-39.105-13.737-39.105a170.957,170.957,0,0,0-20.236-20.155s6.351,15.825-6.638,15.081-12.81-18.928-12.81-18.928-24.961,3.255-40.341,16.689-24.782,49.256-24.782,49.256C2991.723,1537.353,2998.294,1540.339,2998.294,1540.339Z",
    transform: "translate(-2989.484 -1408.679)",
    fill: "#e7eff6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M3437.434,1853.086c.934,7.581,5.985,8.945,5.985,8.945h49.063l-26-10.506.309-1.442,1.9-8.907.04-.2.762-3.56c-.278-.286-.56-.56-.842-.828h0a56,56,0,0,1-27.241-5.736,17.563,17.563,0,0,0-1.715.672l-.014.179S3436.5,1845.5,3437.434,1853.086Z",
    transform: "translate(-3435.904 -1702.105)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M3380.494,1758.174a22.9,22.9,0,0,0,3.776,4.209c4.645,4.2,13.844,9.972,29.014,9.471a61.52,61.52,0,0,0,6.324-.546s3.883-16.416,5.375-25.971l-9.854,21.794s-.681.081-1.886.139h0a56,56,0,0,1-27.24-5.736A44.941,44.941,0,0,1,3380.494,1758.174Z",
    transform: "translate(-3380.492 -1632.783)",
    fill: "#c2d0db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M3393.443,1893.878a11.751,11.751,0,0,1,3-1.155c6.517-1.563,14.194,1.693,14.194,1.693l1.146.443,11.457,4.429c-4.846-2.517-9.079-4.765-11.148-5.871l1.9-8.906.04-.2-3.565.2-2.132,7.124a25.547,25.547,0,0,0-5.343-.488C3396.905,1891.245,3393.645,1893.716,3393.443,1893.878Z",
    transform: "translate(-3381.203 -1745.439)",
    fill: "#f4a984"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(100.783 50.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M2898.5,1571.469s-2.12,7.724-3.579,9.068a5.047,5.047,0,0,1-2.579,1.455l-3.682-14.467,1.107-2.661Z",
    transform: "translate(-2861.64 -1537.447)",
    fill: "#f4a984"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(20.956 11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(7.502 5.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M2862.772,1549.149l3.379,1.305a.875.875,0,0,1,.532,1.033l-2.159,8.438a.875.875,0,0,1-.532.6l-2.567.993a.875.875,0,0,1-.881-.148l-2.044-1.729a.875.875,0,0,1-.253-.976l3.391-9.008A.874.874,0,0,1,2862.772,1549.149Z",
    transform: "translate(-2852.543 -1541.726)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M2883.238,1510.791l2.478,3.3a1.459,1.459,0,0,1,.259,1.18l-2.346,10.944a1.458,1.458,0,0,1-1.151,1.127l-1.105.213a1.459,1.459,0,0,1-1.408-.512l-4.609-5.672a1.458,1.458,0,0,1-.1-1.7l5.583-8.789A1.459,1.459,0,0,1,2883.238,1510.791Z",
    transform: "translate(-2875.029 -1510.208)",
    fill: "#ffba94"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M2889.285,1488l8.541-6.679a2.39,2.39,0,0,1,2.558-.247l4.072,2.076a1.116,1.116,0,0,1,.594,1.178l-1.769,10.612-9.182,5.149Z",
    transform: "translate(-2889.285 -1480.815)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M2892.615,1511.073l-1.4,8.4-5.709,3.2,6.357-2.754,1.852-7.378Z",
    transform: "translate(-2877.219 -1505.343)",
    fill: "#f4a984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M2871.351,1557.653l1.76,2.167,4.784-2.282,1.406-7.251-1.25-.484-1.115,5.208Z",
    transform: "translate(-2860.124 -1536.738)",
    fill: "#f4a984"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M2929.2,1520.532c.448,0,4.527,2.823,4.527,2.823l-3.743.984,3.025,6-2.073,2.246-5.879-7.818Z",
    transform: "translate(-2903.764 -1501.51)",
    fill: "#f4a984"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(7.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M2900.783,1425.924l-.184.145a1.07,1.07,0,0,0-.18,1.5l25.725,32.706,1.026-.806Z",
    transform: "translate(-2900.19 -1424.82)",
    fill: "#ff7db2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 42.681,
    height: 1.305,
    transform: "translate(26.976 34.654) rotate(-128.173)",
    fill: "#fb679b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M2889.4,1420.365l-.036.028,26.386,33.547,1.026-.806-25.608-32.558A1.26,1.26,0,0,0,2889.4,1420.365Z",
    transform: "translate(-2887.742 -1420.096)",
    fill: "#f2518e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M2871.484,1591.383l4.041,8.3-7.118-5.884h0l-.385-1.545,1.411.739h0l-.385-1.545,1.411.738h0l-.385-1.545,1.411.738h0Z",
    transform: "translate(-2842.453 -1558.344)",
    fill: "#ffe0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M2873.473,1599.686l-5.067-7.5-.385-1.545,1.411.738Z",
    transform: "translate(-2840.402 -1558.344)",
    fill: "#f7cc9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M2869.432,1595.64l5.067,7.5-6.092-6.691-.385-1.545Z",
    transform: "translate(-2841.427 -1561.796)",
    fill: "#fcd2a9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M2870.4,1626.506l-2.379-1.967,1.028-.809Z",
    transform: "translate(-2837.329 -1585.164)",
    fill: "#7a7b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M2870.058,1627.66l-2.036-2.236.343-.27Z",
    transform: "translate(-2836.986 -1586.318)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M2869.715,1626.506l-1.693-2.506.343-.27Z",
    transform: "translate(-2836.643 -1585.164)",
    fill: "#4c4c4c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M2903.473,1588.95l5.249,9.017s8.99,7.613,15.912,5.185,10.32-8.737,11.776-14.894-2.24-55.3-2.24-55.3l-1.68-13.434-4.68-8.109a.458.458,0,0,1,.358-.685l5.267-.475a1.454,1.454,0,0,0,1.313-1.648l-.21-1.558a1.454,1.454,0,0,0-1.209-1.245l-8.474-1.392a2.847,2.847,0,0,0-3.122,1.791l-3.74,9.739a2.447,2.447,0,0,0,.04,1.849l4.386,11.622a2.43,2.43,0,0,1,.157,1.415l-8.037,39.18a.307.307,0,0,1-.009.063v0l-1.823,9.488Z",
    transform: "translate(-2903.473 -1488.411)",
    fill: "#ffba94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(71.542 46.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M3187.168,1396.62a60.069,60.069,0,0,0,9.231,3.166l.22-.86.112-.443a58.417,58.417,0,0,1-8.815-3c-.071-.027-.138-.058-.21-.09Z",
    transform: "translate(-3187.168 -1395.389)",
    fill: "#232641"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(0.582 0.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M3187.168,1396.243a59.15,59.15,0,0,0,8.868,3.067l.112-.443a58.446,58.446,0,0,1-8.815-3Z",
    transform: "translate(-3187.168 -1395.862)",
    fill: "#3f4f6d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 1.457,
    cy: 1.457,
    r: 1.457,
    transform: "translate(8.164 2.343)",
    fill: "#232641"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(55.523 24.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(3.585 9.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M3229.692,1344.771c2.15,4.066,6.266,6.166,9.415,4.9a3.975,3.975,0,0,0,.475-.215c3.2-1.693,3.955-6.533,1.693-10.809s-6.692-6.381-9.89-4.688a4.849,4.849,0,0,0-1.285.976s0,0,0,0C3228.026,1337.114,3227.775,1341.144,3229.692,1344.771Z",
    transform: "translate(-3228.389 -1333.375)",
    fill: "#232641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M3238.978,1349.878c2.15,4.066,6.266,6.166,9.415,4.9.076-.081.148-.161.22-.246,1.872-2.221,2.038-6.09.188-9.587-2.141-4.048-6.212-6.148-9.352-4.926a.347.347,0,0,0-.063.022s0,0,0,0C3237.312,1342.221,3237.061,1346.251,3238.978,1349.878Z",
    transform: "translate(-3237.675 -1338.483)",
    fill: "#232641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M3236.232,1338.887c3.14-1.223,7.211.878,9.353,4.926,1.85,3.5,1.684,7.366-.188,9.587a.268.268,0,0,0,.054-.018c2.074-2.176,2.329-6.206.407-9.833-2.154-4.075-6.266-6.175-9.415-4.9,0,0,0,0,0,0C3236.367,1338.726,3236.295,1338.807,3236.232,1338.887Z",
    transform: "translate(-3234.459 -1337.348)",
    fill: "#232641"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M3280.7,1282.729s1.033,5.428,7.042,9.987l-1.511.533s-4.493-2.612-6.549-10.006Z",
    transform: "translate(-3279.683 -1282.729)",
    fill: "#232641"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M3075.591,1677.584l.323.17c1.048-.161,2.078-.358,3.077-.578-1.868-17.061,3.722-39.92,3.87-40.529C3075.837,1655.092,3075.591,1677.584,3075.591,1677.584Z",
    transform: "translate(-2980.625 -1544.679)",
    fill: "#c2d0db"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(2160.726 3134.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M3803.993,941.327h20.832a5.312,5.312,0,0,0,.406-10.609c.02-.258.029-.515.029-.775a10.578,10.578,0,0,0-14.883-9.655,18.415,18.415,0,0,0-35.267-4.328,12.876,12.876,0,1,0-3.126,25.367h11.256",
    transform: "translate(-3759.108 -904.519)",
    fill: "none",
    stroke: "#e7eff6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M3874.583,993.453v-10.6h-3.577l9.6-11.491,9.607,11.491h-3.582v.092c0,12.547-.362,13.129,9.006,13.129h9.809a6.221,6.221,0,0,1-6.192,4.209h-18.391c-2.458,0-5.1-.854-5.979-4.209A10.377,10.377,0,0,1,3874.583,993.453Z",
    transform: "translate(-3850.756 -959.261)",
    fill: "none",
    stroke: "#e7eff6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    fillRule: "evenodd"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(2562.947 3321.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M3294.437,1848.745a138.3,138.3,0,0,0,55.626-28.556c27.81-23.736-33.956-11.08-83.267,10.429l21.159,15.737Z",
    transform: "translate(-3214.428 -1676.537)",
    fill: "#0e2d34",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(36.412 79.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M3270.024,1573.761c-9.2,10.468-33.786,31.886-57.47,54.479l-26.96,13.381-6.988-16.607c16.764-33.177,40.01-67.7,61.327-86.139C3277.326,1506.521,3302.318,1537.025,3270.024,1573.761Z",
    transform: "translate(-3178.606 -1525.198)",
    fill: "#1b7154",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M3215.32,1704.679c27.57-54.177,84.585-101.109,84.793-101.282a.879.879,0,0,1,1.3.173,1.049,1.049,0,0,1-.177,1.4c-.2.17-56.308,46.356-83.809,99.663l-1.758.872Z",
    transform: "translate(-3208.678 -1589.076)",
    fill: "#0e2d34",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(39.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M3194.8,1124.545c-1.279,14.527-.147,47.571-.075,82.051,7.486,12.032,11.062,45.8,24.129,50.445,11.45-35.621,27.063-99.942,25.846-129.041C3242.318,1071.043,3199.669,1069.24,3194.8,1124.545Z",
    transform: "translate(-3194.194 -1084.151)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M3285.562,1294.963c13.788-58.588,9.556-123.887,9.539-124.158a1.116,1.116,0,0,0-1.1-1.075,1.032,1.032,0,0,0-.968,1.135c.015.27,4.195,64.814-9.294,122.8Q3284.64,1294.327,3285.562,1294.963Z",
    transform: "translate(-3267.538 -1154.246)",
    fill: "#5f9850",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(0 36.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M3023.653,1320.06c3.382,13.521,12.461,70.173,17.586,102.5l-9.746,5.537-17.636-3.69c-17.767-32.652-32.952-71.4-36.01-99.42C2972.484,1275.832,3011.787,1272.609,3023.653,1320.06Z",
    transform: "translate(-2977.347 -1286.232)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M3112.742,1488.493c-28.9-53.477-35.107-127.064-35.131-127.333a.881.881,0,0,1,.881-.969,1.048,1.048,0,0,1,1.047.94c.024.266,6.133,72.676,34.356,125.6l-.282,1.94Z",
    transform: "translate(-3059.469 -1346.811)",
    fill: "#0e2d34",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(2565.477 3493.168)",
    style: {
      isolation: "isolate"
    }
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M3101.209,2037.717v3.745c0,1.587-1.9,2.87-4.252,2.87H2991.333v-6.615c0-3.815,4.584-6.912,10.237-6.912h89.4C3096.625,2030.805,3101.209,2033.9,3101.209,2037.717Z",
    transform: "translate(-2991.333 -2030.805)",
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M3124.862,2105.571l-.992,5.716-13.206,76.173h-.67c-3.162,2.193-17.266,3.85-34.187,3.85-7.11,0-13.725-.292-19.237-.793-1.633-.152-3.167-.315-4.59-.5-6.8-.875-11.036-2.117-11.036-3.494,0-.321.239-.635.671-.939l-14.816-80.017Z",
    transform: "translate(-3020.382 -2092.044)",
    fill: "#fff"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M3101.209,2037.717v3.745c0,1.587-1.9,2.87-4.252,2.87h-1.143l-.991,5.716s-67.126,19.552-71.892,78.728v.006c-6.8-.875-11.036-2.117-11.036-3.494,0-.321.239-.636.671-.939l-14.816-80.017h-6.416v-6.615c0-3.815,4.584-6.912,10.237-6.912h89.4C3096.625,2030.805,3101.209,2033.9,3101.209,2037.717Z",
    transform: "translate(-425.856 1462.363)",
    fill: "#eceff8"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(2276.894 3018.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(72.607 68.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1704.22,1644.493l2.489,1.195a1.22,1.22,0,0,0,1.467-.322l20.688-19.757,10.849,8.036-22.622,32.727a7.53,7.53,0,0,1-7.956,3.613l-11.209-2.187Z",
    transform: "translate(-1645.374 -1621.389)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1436.069,1648.382a126.032,126.032,0,0,1-32.948-7.224,73.539,73.539,0,0,1-12.456-6.035c-18.885-11.652,5.625-30.537,5.625-30.537l6.457-4.219s16.136,11.785,30.376,18.37c1.848.852,3.66,1.619,5.4,2.262a7.749,7.749,0,0,1,5.047,6.288C1444.265,1632.849,1443.876,1641.877,1436.069,1648.382Z",
    transform: "translate(-1383.518 -1600.367)",
    fill: "#383b54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1533.75,1703.441a126.021,126.021,0,0,1-32.948-7.224v-29.741s24.912,23.706,29.332,20.492c3.263-2.375,1.708-9.571.671-13.171,1.848.852,3.66,1.619,5.4,2.262a7.749,7.749,0,0,1,5.047,6.288C1541.947,1687.907,1541.557,1696.936,1533.75,1703.441Z",
    transform: "translate(-1481.199 -1655.425)",
    fill: "#232641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1661.467,1735.324c-3.021,1.342-8.667.442-10.439.108a.312.312,0,0,1-.173-.518,42.632,42.632,0,0,0,7.353-13.006c.852-2.306,1.25-3.861,1.25-3.861h5.224l-5.224-2.411c0-4.3-2.475-9.045-3.355-10.6a.186.186,0,0,1,.241-.261l6.959,3.375a7.193,7.193,0,0,1,3.411,3.5,27.152,27.152,0,0,1,1.752,5.095C1670.954,1727.508,1664.445,1734,1661.467,1735.324Z",
    transform: "translate(-1606.104 -1687.308)",
    fill: "#383b54",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1289.291,1555.895l-.8,1.205,3.616,13.26-11.953-6.831-2.913,10.045,18.885,3.616,6.027-14.063-3.214-5.223Z",
    transform: "translate(-1222.395 -1495.223)",
    fill: "#d4dfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M1171.077,1584.742l-4.42,4.018s9.211,9.643,19.874,8.036Z",
    transform: "translate(-1130.297 -1519.248)",
    fill: "#d4dfff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M1083.117,1642.942H973.627s-38.372,6.027-19.086-38.975c10.69-24.94,25.246-38.313,29.635-41.957a1.914,1.914,0,0,1,2.465.01c3.06,2.6,14.236,8.2,24.554,6.588a20.546,20.546,0,0,0,7.413-2.467,12.188,12.188,0,0,0,2.68-2.142c2.988-3.212.909-6.654.187-10.4a.643.643,0,0,1,.819-.742c4.089,1.274,18.855,6.154,22.652,11.331C1049.366,1570.216,1054.991,1610.4,1083.117,1642.942Z",
    transform: "translate(-949.12 -1492.669)",
    fill: "#383b54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1329.327,1521.639l4.822,2.511L1338.97,1535l-9.241-6.429-2.009-3.983Z",
    transform: "translate(-1264.439 -1466.692)",
    fill: "#eef1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M1234.964,1502.661a5.93,5.93,0,0,1-3.214,1.607c-3.271-1.977-8.325-6.738-10.833-6.477-6.252.647-10.949-6.393-10.949-6.393l-1.82-14.376,20.681.812,2.519,15.184A76.635,76.635,0,0,1,1234.964,1502.661Z",
    transform: "translate(-1164.853 -1429.533)",
    fill: "#f9a880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1317.617,1272.664l5.025,11.649-8.173-5.7Z",
    transform: "translate(-1253.402 -1259.332)",
    fill: "#7f5f16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1107.11,1349.906s-7.042.04-5.91,6.712,12.37,11.05,12.37,11.05l1.563-2.48Z",
    transform: "translate(-1075.678 -1323.664)",
    fill: "#af872a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1204.062,1305.149c-1.236,10.6-19.338,18.928-33.228.061-12.166-16.526-8.343-30.2,2.079-32.226s17.72.909,17.72.909,3.148,4.634,6.221,10.366a72.543,72.543,0,0,1,4.24,9.23C1202.388,1297.057,1204.581,1300.7,1204.062,1305.149Z",
    transform: "translate(-1127.469 -1259.005)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1163.511,1427.111s-3.627-2.978-6.387.521,1.1,9.368,5.59,10.458,5.45-3.718,5.45-3.718Z",
    transform: "translate(-1121.586 -1386.98)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1146.444,1276.451s-4.363-10.232-2.9-10.351,28.4-8.785,25.348-17.359-11.823-4.33-11.823-4.33S1124.088,1254.745,1146.444,1276.451Z",
    transform: "translate(-1106.989 -1234.927)",
    fill: "#7f5f16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1324.5,1383.148c-.04.022-.08.044-.122.065l-1.617.806a.348.348,0,1,1-.311-.622l1.617-.806a1.8,1.8,0,0,0,.93-1.272,2.9,2.9,0,0,0-.269-1.916l-.092-.184a.893.893,0,0,0-1.1-.555,2.036,2.036,0,0,1-1.777-.007,2.911,2.911,0,0,1-1.379-1.369l-1.3-2.632a.362.362,0,0,1,.159-.466.348.348,0,0,1,.466.158l1.294,2.631a2.214,2.214,0,0,0,1.043,1.044,1.352,1.352,0,0,0,1.179.019,1.575,1.575,0,0,1,2.033.866l.092.184a3.6,3.6,0,0,1,.326,2.379A2.511,2.511,0,0,1,1324.5,1383.148Z",
    transform: "translate(-1257.222 -1343.859)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(60.813 22.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M1313.469,1332.758a4.63,4.63,0,0,0,1.521-.242c.529-.143,1.064-.275,1.532-.378s1.011-.206,1.551-.3a4.591,4.591,0,0,0,1.479-.416c.372-.223.45-.647-.132-1.02a4.858,4.858,0,0,0-3.385-.278,4.683,4.683,0,0,0-2.916,1.658C1312.768,1332.363,1313.032,1332.712,1313.469,1332.758Z",
    transform: "translate(-1312.957 -1329.969)",
    fill: "#7f5f16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1276.1,1387.2a1.62,1.62,0,1,1-2.234-.933A1.717,1.717,0,0,1,1276.1,1387.2Z",
    transform: "translate(-1218.871 -1353.829)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M1338.9,1358.3a1.4,1.4,0,1,1-1.905-1.116A1.585,1.585,0,0,1,1338.9,1358.3Z",
    transform: "translate(-1271.508 -1329.665)",
    fill: "#1d3151"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 6.009,
    cy: 6.009,
    rx: 6.009,
    ry: 6.009,
    transform: "translate(44.9 35.448)",
    fill: "#fca286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1363.641,1353.221a6.007,6.007,0,0,1-4.24-9.23A72.571,72.571,0,0,1,1363.641,1353.221Z",
    transform: "translate(-1290.015 -1318.737)",
    fill: "#fca286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1177.594,1463.5a.4.4,0,0,0,.18-.249l.6-2.362-3.475-1.184a.4.4,0,0,0-.53.283.484.484,0,0,0,.31.569l2.637.9-.383,1.511a.484.484,0,0,0,.312.568A.408.408,0,0,0,1177.594,1463.5Z",
    transform: "translate(-1136.708 -1415.089)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M1326.819,1455.872s-4,2.594-7.969,1.621a4.926,4.926,0,0,0,4.368,1.912A3.687,3.687,0,0,0,1326.819,1455.872Z",
    transform: "translate(-1257.052 -1411.918)",
    fill: "#ff806d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M1131.137,1223.63s20.22-.192,28.658-14.255-8.84-16.474-8.84-16.474.4.4-1.205,2.411-32.948.938-27.322,24.778Z",
    transform: "translate(-1092.898 -1192.902)",
    fill: "#af872a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(49.504 27.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M1246.072,1362.206a4.889,4.889,0,0,0,1.314-.924c.431-.376.871-.746,1.263-1.056s.853-.657,1.317-.991a4.85,4.85,0,0,0,1.2-1.067c.248-.379.129-.808-.584-.886a5.108,5.108,0,0,0-3.293,1.3,4.921,4.921,0,0,0-1.98,2.882C1245.238,1362.163,1245.642,1362.365,1246.072,1362.206Z",
    transform: "translate(-1245.299 -1357.269)",
    fill: "#7f5f16"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M1165.842,1368.9s.4,11.25,3.616,16.474a28.7,28.7,0,0,1-6.632-7.791C1160.618,1373.323,1162.226,1366.895,1165.842,1368.9Z",
    transform: "translate(-1126.267 -1339.17)",
    fill: "#af872a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M1185.888,1542.7s2.411-8.438,3.616-8.438S1205.1,1545,1205.1,1545l.078,11.359C1201.96,1555.956,1185.888,1542.7,1185.888,1542.7Z",
    transform: "translate(-1146.314 -1477.203)",
    fill: "#eef1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M1035.939,1850.92s-1.048-4.912-13.1-4.51h-5.223s8.84-2.411,20.894,0c0,0,12.456-11.251,14.465-14.063,0,0,7.634,26.117,38.171,27.323l-18.483,7.232-30.135-10.045Z",
    transform: "translate(-1006.165 -1725.467)",
    fill: "#232641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M1661.467,1795.038c-3.021,1.342-8.667.442-10.439.108a.312.312,0,0,1-.173-.518,42.635,42.635,0,0,0,7.353-13.006c2.744.277,8.329.141,10.258-5.167C1670.954,1787.223,1664.445,1793.716,1661.467,1795.038Z",
    transform: "translate(-1533.497 -1678.918)",
    fill: "#232641"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(18.018 124.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M1093.9,1992.266s-2.846-15.71,11.157-20.492l36.544,9.563v10.587Z",
    transform: "translate(-1087.524 -1966.31)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M1348.966,2001.66l4.124-.728a1.482,1.482,0,0,0,.232-.061l12.672-4.42a6.348,6.348,0,0,1,3.836-.11l5.013,1.432a1.489,1.489,0,0,1,.417.193l2.594,1.729a1.488,1.488,0,0,0,.629.237l4.162.555a1.487,1.487,0,0,1,.994.582l.182.243a1.488,1.488,0,0,1,.221,1.364l-.325.976a1.483,1.483,0,0,1-.359.582l-.34.34a1.488,1.488,0,0,0-.436,1.052v1.077a1.488,1.488,0,0,1-.535,1.143l-.683.569a1.487,1.487,0,0,0-.429,1.7l.011.029a1.488,1.488,0,0,1-.1,1.3h0a1.489,1.489,0,0,1-1.286.738h-28.489a1.488,1.488,0,0,1-1.446-1.135l-1.849-7.568A1.488,1.488,0,0,1,1348.966,2001.66Z",
    transform: "translate(-1299.128 -1986.568)",
    fill: "#ffba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1076.562,1944.163c-10.913,5.649-10.913,20.878-10.913,20.878h-6.694a1.532,1.532,0,0,1-1.5-1.205,22.247,22.247,0,0,1,.876-12.785.662.662,0,0,1,.784-.386l4.765,1.27-3.166-3.166a1.3,1.3,0,0,1-.173-1.627,20.461,20.461,0,0,1,7.791-7.148,15.955,15.955,0,0,1,1.728-.767,2.213,2.213,0,0,1,2.186.37l4.42,3.64A.557.557,0,0,1,1076.562,1944.163Z",
    transform: "translate(-1056.918 -1939.085)",
    fill: "#383b54",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M1068.43,1949.069c-2.19,3.648-7.028,10.278-5.794,20.492h-3.681a1.532,1.532,0,0,1-1.5-1.205,22.247,22.247,0,0,1,.876-12.785.662.662,0,0,1,.784-.386l4.765,1.27-3.166-3.166a1.3,1.3,0,0,1-.173-1.627,20.461,20.461,0,0,1,7.791-7.148C1069.145,1945.4,1069.748,1946.876,1068.43,1949.069Z",
    transform: "translate(-1056.918 -1943.606)",
    fill: "#232641"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M0,18.411l3.084-2.566L9.136,6.516,19.045,0l1.039,3.188L15.7,7.7l-2.236,12.1L1.1,23.837Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 148.201, 58.4)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M10.148,1.021,24.149,0,20.2,16.668,4.482,19.717,0,13.231Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 152.496, 65.236)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M.04,8.728l2.185-2.1L9.209,4.348,17.286,0a2.144,2.144,0,0,1,1.522,2.61L10.627,8.868,0,12.331Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 167.861, 54.704)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M.04,8.728l2.185-2.1L9.209,4.348,17.287,0a2.143,2.143,0,0,1,1.522,2.61L10.627,8.868,0,12.331Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 172.389, 55.556)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M.04,8.728l2.185-2.1L9.21,4.348,17.287,0a2.144,2.144,0,0,1,1.522,2.61L10.627,8.867,0,12.331Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 173.816, 58.904)",
    fill: "#fbbd9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M.04,8.727.341,2.2,9.209,4.348,17.286,0a2.143,2.143,0,0,1,1.522,2.61L10.627,8.867,0,12.331Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 173.128, 64.197)",
    fill: "#fbbd9d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBanner);
export default __webpack_public_path__ + "static/media/LoginBanner.e1c7983a.svg";
export { ForwardRef as ReactComponent };